/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown>, tasks: NonNullable<unknown> }} Task_Catalog_Copy_DroppedInputs */

const en_task_catalog_copy_dropped = /** @type {(inputs: Task_Catalog_Copy_DroppedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next activities with no match in ${i?.scope} were left out of the copy: ${i?.tasks}.`)
};

const pt_br2_task_catalog_copy_dropped = /** @type {(inputs: Task_Catalog_Copy_DroppedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximas atividades sem correspondente em ${i?.scope} ficaram fora da cópia: ${i?.tasks}.`)
};

/**
* | output |
* | --- |
* | "Next activities with no match in {scope} were left out of the copy: {tasks}." |
*
* @param {Task_Catalog_Copy_DroppedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_copy_dropped = /** @type {((inputs: Task_Catalog_Copy_DroppedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Copy_DroppedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_copy_dropped(inputs)
	return pt_br2_task_catalog_copy_dropped(inputs)
});